'use client';

import Logo from "@/components/Logo";
import MenuIcon from "@/components/icons/MenuIcon";
import MenuCloseIcon from "@/components/icons/MenuCloseIcon";
import {useEffect, useState} from "react";
import NavMain from "@/components/header/NavMain";
import NavHeader from "@/components/header/NavHeader";
import {HeaderSettings} from "@/lib/interfaces/settings";
import {NavigationItem} from "@/lib/interfaces/navigation";
import NavFull from "@/components/header/NavFull";
import {usePathname} from "next/navigation";
import VerifyAccount from "@/components/VerifyAccount";
import {useHeader} from "@/context/header.context";

type HeaderProps = {
    menuItems: NavigationItem[]
    settings: HeaderSettings
}

export default function Header(props: HeaderProps) {
    const [isOpen, setOpen] = useState(false);
    const pathname = usePathname();
    const {content} = useHeader();

    useEffect(() => {
        setOpen(false);
    }, [pathname]);
    return (
        <header>
            <div className="header-site">
                <nav className={`eo-navFull ${isOpen ? 'm-open' : ''}`}>
                    <div className="navFull-toggle" onClick={() => setOpen(!isOpen)}>
                        <span className="toggle-open"><MenuIcon/></span>
                        <span className="toggle-close"><MenuCloseIcon/></span>
                    </div>
                    <div className="navFull-backdrop"></div>
                    <div className="navFull-panel">
                        <NavFull items={props.menuItems}/>
                    </div>
                </nav>
                <Logo href={`/`}/>
                <NavMain items={props.menuItems}/>
                <NavHeader settings={props.settings}/>
            </div>
            <VerifyAccount/>
            {content}
        </header>
    )
}